// These are Statsig experiments
export const MACRO_INTERACTION_DESIGN_UPDATES = 'confluence_frontend_macro_interaction_design';
export const MACRO_INTERACTION_BUTTON_UPDATES = 'confluence_live_macros_config_button_updates';

// This is a Statsig gate
export const LIVE_PAGES_BODIED_MACROS_RENDERER_VIEW =
	'confluence_bodied_macros_rendered_view_live_pages';
